import { render, staticRenderFns } from "./DocumentClassificationSection.vue?vue&type=template&id=0cb1bd44&scoped=true&"
import script from "./DocumentClassificationSection.vue?vue&type=script&lang=js&"
export * from "./DocumentClassificationSection.vue?vue&type=script&lang=js&"
import style0 from "./DocumentClassificationSection.vue?vue&type=style&index=0&id=0cb1bd44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb1bd44",
  null
  
)

export default component.exports